import { createFeatureSelector, createSelector } from "@ngrx/store";
import { PlanesState } from "./planes.reducers";

export const selectPlanesState = createFeatureSelector<PlanesState>('planesReducer');

export const selectPlanes = createSelector(selectPlanesState, (state: PlanesState) => state.data);

export const selectPlanesResponse = createSelector(selectPlanesState, (state: PlanesState) => state.data ? state.data.planes : null);